<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../common/Image/FontAwesomeView.svelte";
    import {BinaryTable} from "../../lib/Table/BinaryTable";

    export let platformType;

    onMount(() => {
    });


</script>

<span class="platform-type-icon-view">
    <div class="icon">
        {#if platformType === BinaryTable.PlatformType.Android }
            <FontAwesomeView icon="android" classification="fab"/>
        {:else if platformType === BinaryTable.PlatformType.IOS }
            <FontAwesomeView icon="apple" classification="fab"/>
        {:else if platformType === BinaryTable.PlatformType.Gpg }
            <FontAwesomeView icon="google-play" classification="fab"/>
        {:else if platformType === BinaryTable.PlatformType.Dmm }
            <FontAwesomeView icon="d" classification="fas"/>
        {/if}

    </div>
    <div class="name">
        {#if platformType === BinaryTable.PlatformType.Android }
            Android
        {:else if platformType === BinaryTable.PlatformType.IOS }
            iOS
        {:else if platformType === BinaryTable.PlatformType.Gpg }
            Google Play Games
        {:else if platformType === BinaryTable.PlatformType.Dmm }
            DMM
        {/if}

    </div>


</span>
<style lang="scss">
    .platform-type-icon-view {
        text-align: center;
        width: 1.5em;
        display: inline-block;

        .name {
            font-size: 0.3em;
            opacity: 0.75;
            text-align: center;
        }
    }
</style>